import React from 'react'
import CouponIcon from 'static/icons/coupon-active.svg'
import * as S from './styles'

const SchedulingCoupon = ({ coupon, removeCoupon }) => {
  return (
    <S.CardWrapper active>
      <S.CouponInfo>
        <CouponIcon />
        <S.CouponTitle>
          <h2>Cupom {coupon.code}</h2>
          <h3>Aplicado no agendamento</h3>
        </S.CouponTitle>
      </S.CouponInfo>
      <S.TrashIcon onClick={removeCoupon} />
    </S.CardWrapper>
  )
}

export default SchedulingCoupon
